const WORDS = ["Strategy", "Finance", "Leadership", "Operations", "Macroeconomics", "Technology", "Peer-reviewed since 2012", "Evidence over opinion"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="border-y border-[var(--ink)] overflow-hidden py-5 bg-[var(--paper)]" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="f-serif italic text-3xl sm:text-5xl px-8 flex items-center gap-16">
            {w}<span className="inline-block w-2.5 h-2.5 rounded-full bg-[var(--red)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
